import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
var _excluded = ["transition", "transitionEnd"];
import { getOrigin, checkTargetForNewValues } from '../utils/setters.mjs';
import { parseDomVariant } from './utils/parse-dom-variant.mjs';
import { VisualElement } from '../VisualElement.mjs';
var DOMVisualElement = /*#__PURE__*/function (_VisualElement) {
  _inherits(DOMVisualElement, _VisualElement);
  var _super = _createSuper(DOMVisualElement);
  function DOMVisualElement() {
    _classCallCheck(this, DOMVisualElement);
    return _super.apply(this, arguments);
  }
  _createClass(DOMVisualElement, [{
    key: "sortInstanceNodePosition",
    value: function sortInstanceNodePosition(a, b) {
      /**
       * compareDocumentPosition returns a bitmask, by using the bitwise &
       * we're returning true if 2 in that bitmask is set to true. 2 is set
       * to true if b preceeds a.
       */
      return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
  }, {
    key: "getBaseTargetFromProps",
    value: function getBaseTargetFromProps(props, key) {
      var _a;
      return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    }
  }, {
    key: "removeValueFromRenderState",
    value: function removeValueFromRenderState(key, _ref) {
      var vars = _ref.vars,
        style = _ref.style;
      delete vars[key];
      delete style[key];
    }
  }, {
    key: "makeTargetAnimatableFromInstance",
    value: function makeTargetAnimatableFromInstance(_ref2, _ref3, isMounted) {
      var transition = _ref2.transition,
        transitionEnd = _ref2.transitionEnd,
        target = _objectWithoutProperties(_ref2, _excluded);
      var transformValues = _ref3.transformValues;
      var origin = getOrigin(target, transition || {}, this);
      /**
       * If Framer has provided a function to convert `Color` etc value types, convert them
       */
      if (transformValues) {
        if (transitionEnd) transitionEnd = transformValues(transitionEnd);
        if (target) target = transformValues(target);
        if (origin) origin = transformValues(origin);
      }
      if (isMounted) {
        checkTargetForNewValues(this, target, origin);
        var parsed = parseDomVariant(this, target, origin, transitionEnd);
        transitionEnd = parsed.transitionEnd;
        target = parsed.target;
      }
      return _objectSpread({
        transition: transition,
        transitionEnd: transitionEnd
      }, target);
    }
  }]);
  return DOMVisualElement;
}(VisualElement);
export { DOMVisualElement };